 {{loadFocustelements()}}
<div (keydown)="handleKeydown($event)" class="ctn-model-box">
  <div class="ctn-modal-header">
    <h2 tabindex="0">{{modalPopupObject.modalHeader}} </h2>
  </div>
  <div class="ctn-alert" *ngIf="noRecordsFound">
      <div class="alert valign-children-middle">
        <div class="alert-info" role="img" aria-label="Alert">
          <i class="icon-alert"></i>
        </div>
        <div ><span tabindex="0">We couldn’t find a match for "{{ctnNumbertoFormate.value}}". Check the number and try again.</span></div>
      </div>
    </div>
    <div class="ctn-alert" *ngIf="systemError">
      <div class="alert valign-children-middle">
        <div class="alert-error" role="img" aria-label="Alert">
          <i class="icon-badgealert"></i>
        </div>
        <div><span tabindex="0">Something isn’t working. We couldn’t perform your search. Please try again.</span></div>
      </div>
    </div>
  <div class="ctn-box-outer">
       
    <div class="corner-button">
      <button class="close" aria-label="Close" (click)="btnAction(false)" (keydown)="btnAction(false, $event)">x</button>
    </div>

    <div class="ctn-modal-body box-outer">
      <p [innerHtml]="modalPopupObject.modalMessage"></p>
      <p class="ctn-field-label" >{{modalPopupObject.ctnFieldLabel}}</p>
      <input  [ctnmask]=true [formControl]="ctnNumbertoFormate" (rawChange)="ctnNumber=$event" type="text" (keydown)="handleCtnFieldChange()"
        maxlength="12" placeholder="" class="form-control ctn-field" attr.aria-label="{{modalPopupObject.ctnFieldLabel}}" aria-describedby="numberError" 
        (keyup.enter)="(ctnNumber && ctnNumber.length == 10) ? ctnNumberLookUp(ctnNumber) : ''" />
    </div>

    <div class="numberError" id="numberError" *ngIf="validNumberError">Error! Enter a valid wireless number.</div>   

  </div>
  <div class="text-right ctn-modal-footer">
    <div class="button-group">
      <button class="btn btn-secondary pull-right" (click)="ctnNumberLookUp(ctnNumber)"  (keydown)="ctnNumberLookUp(ctnNumber, $event)" type="submit" [disabled]="((!ctnNumbertoFormate.value) || (ctnNumber.length != 10))"  attr.aria-label="{{modalPopupObject.ctnlookupButtonMessage}}">{{modalPopupObject.ctnlookupButtonMessage}}</button>
      <a href="javascript:void(0)" class="btn btn-link cancel-button-modal" (click)="btnAction(false)" (keydown)="btnAction(false, $event)" role="button" attr.aria-label="{{modalPopupObject.cancelButtonMessage}}">{{modalPopupObject.cancelButtonMessage}}</a>
    </div>
    <div class="clearfix"></div>
  </div>
</div>